<lib-dropdown-box
	rule="tabOptions"
	[(ngModel)]="activeTab"
	[list]="dropDownModel"
	(ngModelChange)="changeRoute($event)"
	class="form-control toggle mt-1"
	[isBody]="true" />
